import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type UpdateMissionTrackingPas = {
  amount: number | null
}
export function updateMissionTrackingPas(input: IdInput<UpdateMissionTrackingPas>) {
  const { id, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.missionTrackings.updateMissionTrackingPas.url, { id }))
    .patch<UpdateMissionTrackingPas>(rest)
}
